import {
  GET_SOCURE_CAPTURE,
  GET_SOCURE_CAPTURE_ERROR,
  GET_SOCURE_CAPTURE_SUCCESS,
  SOCURE_UPLOAD_DOCUMENT,
  SOCURE_UPLOAD_DOCUMENT_SUCCESS,
  SOCURE_UPLOAD_DOCUMENT_ERROR,
  SOCURE_VERIFICATION,
  SOCURE_VERIFICATION_SUCCESS,
  SOCURE_VERIFICATION_ERROR,
  GET_REQUIRED_DOCUMENTS,
  GET_REQUIRED_DOCUMENTS_SUCCESS,
  GET_REQUIRED_DOCUMENTS_ERROR,
  SOCURE_EVENT,
  SOCURE_EVENT_SUCCESS,
  SOCURE_EVENT_ERROR,
} from './documentsActionConstants';

// Get Required Documents
export const getRequiredDocuments = (payload) => ({
  type: GET_REQUIRED_DOCUMENTS,
  payload,
});

export const getRequiredDocumentsSuccess = (payload) => ({
  type: GET_REQUIRED_DOCUMENTS_SUCCESS,
  payload,
});

export const getRequiredDocumentsError = (payload) => ({
  type: GET_REQUIRED_DOCUMENTS_ERROR,
  payload,
});

// Get Socure Capture Response
export const getSocureCapture = (payload) => ({
  type: GET_SOCURE_CAPTURE,
  payload,
});

export const getSocureCaptureSuccess = (payload) => ({
  type: GET_SOCURE_CAPTURE_SUCCESS,
  payload,
});

export const getSocureCaptureError = (payload) => ({
  type: GET_SOCURE_CAPTURE_ERROR,
  payload,
});

// Get Socure Capture Response
export const socureUploadDocument = (payload) => ({
  type: SOCURE_UPLOAD_DOCUMENT,
  payload,
});

export const socureUploadDocumentSuccess = (payload) => ({
  type: SOCURE_UPLOAD_DOCUMENT_SUCCESS,
  payload,
});

export const socureUploadDocumentError = (payload) => ({
  type: SOCURE_UPLOAD_DOCUMENT_ERROR,
  payload,
});

// Get Socure Capture Response
export const socureVerification = (payload) => ({
  type: SOCURE_VERIFICATION,
  payload,
});

export const socureVerificationSuccess = (payload) => ({
  type: SOCURE_VERIFICATION_SUCCESS,
  payload,
});

export const socureVerificationError = (payload) => ({
  type: SOCURE_VERIFICATION_ERROR,
  payload,
});

// Get Required Documents
export const socureEvent = (payload) => ({
  type: SOCURE_EVENT,
  payload,
});

export const socureEventSuccess = (payload) => ({
  type: SOCURE_EVENT_SUCCESS,
  payload,
});

export const socureEventError = (payload) => ({
  type: SOCURE_EVENT_ERROR,
  payload,
});
